/* eslint-disable no-underscore-dangle */

import { RiDeleteBin6Line } from "react-icons/ri"
import {
  setAccessType,
  setAdminRoutes,
  setServerRoutes,
  deleteAccessType,
  deleteClientRoute,
  deleteServerRoute,
  addClientRoute,
  addServerRoute,
} from "@features/admin/modules/moduleSlice"
import { useDispatch } from "react-redux"

const methods = ["GET", "POST", "PUT", "PATCH", "DELETE"]

const Path = ({ each, pathIndex }) => {
  const dispatch = useDispatch()

  const handleAccessTypeChange = (name) => (e) => {
    dispatch(
      setAccessType({ index: pathIndex, key: name, value: e.target.value }),
    )
  }

  const handleAdminRoutesChange = (index) => (e) => {
    dispatch(
      setAdminRoutes({
        index: pathIndex,
        adminIndex: index,
        value: e.target.value,
      }),
    )
  }

  const handleServerRoutesChange = (index, name) => (e) => {
    dispatch(
      setServerRoutes({
        index: pathIndex,
        serverIndex: index,
        serverKey: name,
        value: e.target.value,
      }),
    )
  }

  return (
    <section className="rounded py-1 bg-gray-100 mb-4 shadow-md">
      <div className="flex items-center">
        <div className="flex-1 pb-1 pl-4 mr-2">
          <label className="block uppercase tracking-wide text-gray-800 mb-1 ">
            Access Type
          </label>
          <input
            className="inputbox w-full bg-white"
            id={`${each._id}-access-type-${pathIndex}`}
            type="text"
            value={each.access_type}
            onChange={handleAccessTypeChange("access_type")}
            placeholder="Access Type Name"
          />
        </div>
        <div className="flex-1 pb-1 pl-4 mr-2">
          <label className="block uppercase tracking-wide text-gray-800 mb-1 ">
            Access Type Description
          </label>
          <input
            className="inputbox w-full bg-white"
            id={`${each._id}-access-type-${pathIndex}`}
            type="text"
            value={each.access_type_description}
            onChange={handleAccessTypeChange("access_type_description")}
            placeholder="Access Type Description"
          />
        </div>
        <div className="flex justify-center w-8 text-center h-8 mt-6">
          <span
            className="w-6 inline-flex justify-center items-center leading-none cursor-pointer relative"
            onClick={() => dispatch(deleteAccessType({ index: pathIndex }))}
          >
            <RiDeleteBin6Line className="tbltrash text-xs text-red-400 hover:text-red-500" />
          </span>
        </div>
      </div>

      <div className="flex justify-between">
        <div className="clientRoute w-1/2 border-r border-gray-400">
          <div className="flex mb-2">
            <label className="label uppercase tracking-wide text-gray-800 text-xs pl-4">
              Client Route
            </label>
          </div>
          {(each.admin_routes || []).map((eachAdminRoute, index) => (
            <div
              className="w-full pb-1 pl-4"
              key={`${each._id}-${pathIndex}-each-admin-route-${index}`}
            >
              <div className="flex items-center">
                <input
                  className="flex-1 inputbox mr-2"
                  id={`${each._id}-each-admin-route-access-type-${index}`}
                  type="text"
                  value={eachAdminRoute}
                  onChange={handleAdminRoutesChange(index)}
                  style={{ background: "#FFFFFF" }}
                />

                <span
                  className="w-6 inline-flex justify-center items-center leading-none cursor-pointer relative"
                  onClick={() =>
                    dispatch(
                      deleteClientRoute({
                        index: pathIndex,
                        adminIndex: index,
                      }),
                    )
                  }
                >
                  <RiDeleteBin6Line className="tbltrash text-xs text-red-400 hover:text-red-500" />
                </span>
              </div>
            </div>
          ))}
          <div className="border-t border-gray-400 pt-1">
            <button
              className="py-1 px-2 text-sm rounded font-bold hover:text-black text-blue-500  ml-4"
              onClick={() => dispatch(addClientRoute({ index: pathIndex }))}
            >
              Add Client Route
            </button>
          </div>
        </div>
        <div className="serverRoute w-1/2">
          <div className="flex mb-2">
            <label className="uppercase tracking-wide text-gray-800 text-xs pl-4">
              Method
            </label>
            <label className=" uppercase tracking-wide text-gray-800 text-xs pl-16">
              Server Route
            </label>
          </div>
          {(each.server_routes || []).map((eachServerRoute, index) => (
            <div
              className="w-full pb-1 pl-4"
              key={`${each._id}-${pathIndex}-${eachServerRoute._id}-each-server-route-${index}`}
            >
              <div className="flex">
                <div className="mr-2">
                  <select
                    className="inputbox"
                    placeholder="Method"
                    value={eachServerRoute.method}
                    onChange={handleServerRoutesChange(index, "method")}
                    inputprops={{
                      name: "Method",
                      id: `${each._id}-${eachServerRoute._id}-each-server-route-${index}-method`,
                    }}
                    style={{ minWidth: "80px", background: "#FFFFFF" }}
                  >
                    {methods.map((eachMethod) => (
                      <option
                        key={`${eachMethod._id}-${pathIndex}-${eachServerRoute._id}-each-server-route-method-${eachMethod}`}
                        value={eachMethod}
                      >
                        {eachMethod}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex items-center w-full">
                  <input
                    type="text"
                    className="inputbox mr-2 flex-1"
                    style={{ background: "#FFFFFF" }}
                    id={`${each._id}-${eachServerRoute._id}-each-admin-server-route-route-access-type-${index}`}
                    value={eachServerRoute.route}
                    onChange={handleServerRoutesChange(index, "route")}
                  />
                  <span
                    className="w-6 inline-flex justify-center items-center leading-none cursor-pointer relative"
                    onClick={() =>
                      dispatch(
                        deleteServerRoute({
                          index: pathIndex,
                          serverIndex: index,
                        }),
                      )
                    }
                  >
                    <RiDeleteBin6Line className="tbltrash text-xs text-red-400 hover:text-red-500" />
                  </span>
                </div>
              </div>
            </div>
          ))}

          <div className="border-t border-gray-400 pt-1">
            <button
              className="py-1 text-sm rounded font-bold hover:text-black text-blue-500  ml-4"
              onClick={() => dispatch(addServerRoute({ index: pathIndex }))}
            >
              Add Server Route
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Path
